module.exports = __webpack_public_path__ + "e31494a51c162d8a35e474468fc832f5.ttf";